/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'publish__icon': {
    width: 94,
    height: 60,
    viewBox: '0 0 94 60',
    data: '<rect pid="0" y="60" width="60" height="80" rx="6" transform="rotate(-90 0 60)" _fill="#62E2AA"/><rect pid="1" x="8" y="28" width="20" height="20" rx="2" transform="rotate(-90 8 28)" _fill="#2E48DA"/><rect pid="2" x="36" y="28" width="20" height="20" rx="2" transform="rotate(-90 36 28)" _fill="#2E48DA"/><circle pid="3" cx="74" cy="18" r="10" _fill="#2E48DA"/><path pid="4" d="M74 32c-11.046 0-20 8.954-20 20h40c0-11.046-8.954-20-20-20z" _fill="#2E48DA"/><rect pid="5" x="8" y="36" width="40" height="4" rx="2" _fill="#2E48DA"/><rect pid="6" x="8" y="48" width="40" height="4" rx="2" _fill="#2E48DA"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/publish__icon.js